import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';
import { useFpId } from '../../FinancialPlanOPL/hooks/useFpId';
import { PlanActionStepDTO } from '../../FinancialPlanOPL/types/planActionStepsDTO';
import { notifyPdfLoadedSection } from '../../PDFRenderer/PDFRendererActions';
import { PdfSectionType } from '../../PDFRenderer/PDFRendererTypes';
import { GoalTypeDTO } from '../../FinancialPlanOPL/types/goalsDTO';
import { PlanActionStepsAdvisersAssigneesDTO } from '../../FinancialPlanOPL/types/planActionStepsAdvisersAssigneesDTO';

export interface ActionStepsDTO {
  Goals: { Id: string; Name: string; Type: GoalTypeDTO }[];
  OtherGoals: { Category: number; Name: string }[];
  Tasks: PlanActionStepDTO[];
  Options: {
    DebtTypes: { label: string; value: number }[];
  };
  PlanActionStepsAdvisersAssignees: PlanActionStepsAdvisersAssigneesDTO | null;
  ActionStepAssetBucketOptions: {
    AllowAssetBucketingCustomization: boolean;
    AvailableAssetBuckets: { Title: string }[];
  };
}

interface FetcherParams {
  clientId: number;
  fpId: string;
}

const fetchActionSteps = async ({ clientId, fpId }: FetcherParams): Promise<ActionStepsDTO> => {
  return authFetch(urlWithParams('/Consumer/TasksV2', { clientId, fpId }));
};

export const useActionStepsQuery = () => {
  const clientId = useClientId();
  const fpId = useFpId();

  const dispatch = useDispatch();

  return useQuery(
    queryKeys.actionSteps(clientId, fpId),

    () => fetchActionSteps({ clientId, fpId }),

    {
      cacheTime: 0,
      enabled: !!fpId,

      onSuccess() {
        dispatch(notifyPdfLoadedSection(PdfSectionType.ActionSteps));
      },
    },
  );
};
